import api from '../../../../helpers/api';

// big_numbers "/big-numbers" => Os big numbers
// geo_locations "/geo-locations" => Os pins
// Detalhamento "/detailed-info-window" => O relatório completo do pin
// Info Window "/pinned-info-window" => A info window do pin
// transactioned_over_existing_realties "/transactioned-over-existing-realties" => O grafico
// list "/list" => Busca os anos com transações

export const getBigNumbers = (payload) => {
  return api.post(
    'developer/bloomberg/transactioned-realties-metrics/big-numbers',
    payload
  );
};

export const getMarkers = (payload) => {
  return api.post(
    'developer/bloomberg/transactioned-realties-metrics/geo-locations',
    payload
  );
};

export const getBuildingDetails = (payload) => {
  return api.post(
    'developer/bloomberg/transactioned-realties-metrics/detailed-info-window',
    payload
  );
};

export const getTransactionedOverExisting = (payload) => {
  return api.post(
    'developer/bloomberg/transactioned-realties-metrics/transactioned-over-existing-realties',
    payload
  );
};

export const getTransactionsList = () => {
  return api.get('developer/bloomberg/transactioned-realties-metrics/list');
};

export const getInfoWindow = (payload) => {
  return api.post(
    'developer/bloomberg/transactioned-realties-metrics/pinned-info-window',
    payload
  );
};

export const getMigratoryOrigin = (payload) =>
  api.post(
    'developer/bloomberg/transactioned-realties-metrics/migratory_origin',
    payload
  );
